/**
 * Enum for Wathiq form field keys
 */
export enum WathiqFieldKey {
  NAME = 'name',
  EMAIL = 'email',
  FILE = 'file',
}
